import * as angular from 'angular';

import { ComponentDefinition, KeyValuePair } from '../../models';
import { Helper } from '../../common';

// Extremely similar to LabelsEditor

class MultiCategorySelectorController implements angular.IComponentController {

    model: string[];
    onSelect?: (value: { item: KeyValuePair<string, string> }) => void;
    onRemove?: (value: { item: KeyValuePair<string, string> }) => void;

    static $inject = ['$translate'];
    constructor(private readonly _$translate: angular.translate.ITranslateService) {
        this.create = this.create.bind(this);
    }

    select($item: KeyValuePair<string, string>) {
        const toReplace = ` ${this._$translate.instant('(Enter to create)')}`;
        $item.value = $item.value.replace(toReplace, '');
        if (this.onSelect) {
            this.onSelect({ item: $item });
        }
    }

    remove($item: KeyValuePair<string, string>) {
        if (this.onRemove) {
            this.onRemove({ item: $item });
        }
    }

    create(newTag: string) {
        const toReplace = ` ${this._$translate.instant('(Enter to create)')}`;
        return {
            key: Helper.getGuid(),
            value: `${newTag}${toReplace}`
        };
    }
}

export const wtMultiCategorySelector: ComponentDefinition = {
    componentId: 'wtMultiCategorySelector',
    controller: MultiCategorySelectorController,
    template: require('./multiCategorySelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        disabled: '<?',
        model: '=',
        name: '<',
        options: '=',
        onRemove: '&?',
        onSelect: '&?',
        placeholder: '<',
    }
};
